import React from 'react';
import { SlideFrame } from './SlideFrame';
const followUpSteps = ['Share selected live-poll findings', 'Add key congress insights', 'Link to relevant scientific content', 'Invite the next step'];
const practicalValue = ['Extends congress impact', 'Creates useful follow-up', 'Enables lead generation', 'Supports rep follow-up', 'Builds momentum into the next activity'];
export function EncoreSlide() {
  return <SlideFrame topBand eyebrow="The encore" data-id="element-114" data-mp="1v6ddygje97ns">
      <div className="grid min-h-0 flex-1 grid-rows-[auto_auto_minmax(0,1fr)_auto]" data-id="element-115" data-mp="1q823c3l9yt4i">
        <header className="grid grid-cols-[1.1fr_0.9fr] items-end gap-[5vw]" data-id="element-116" data-mp="1m6702tjsa5o3">
          <h1 className="max-w-[12ch] font-display text-[clamp(44px,5.8vw,96px)] font-bold leading-[0.96] tracking-[-0.03em]" data-id="element-117" data-mp="1m8be44becl23">
            Give the knowledge back.
          </h1>
          <p className="mb-[0.6vh] max-w-[36ch] font-sans text-[clamp(13px,1.05vw,19px)] leading-snug text-black/55" data-id="element-118" data-mp="asmqrbu8dk0r">
            After ECCO, continue the conversation by sharing what the community told us.
          </p>
        </header>

        <div className="mt-[2.2vh] grid grid-cols-4 border-y border-black/20" data-id="element-119" data-mp="dxoflz98eqzg">
          {followUpSteps.map((step, index) => <div key={step} className={`relative min-h-[8.5vh] py-[1.1vh] pr-[1.2vw] ${index > 0 ? 'border-l border-black/15 pl-[1.2vw]' : ''}`} data-id="element-120" data-mp="3w42rlsnxwqv7" data-mpi={index}>
              <span className="font-sans text-[clamp(10px,0.72vw,13px)] font-semibold tracking-[0.1em] text-[#D62B22]" data-id="element-121" data-mp="3mcyfr1tk9m4l">
                0{index + 1}
              </span>
              <p className="mt-[0.35vh] max-w-[19ch] font-display text-[clamp(15px,1.35vw,24px)] font-medium leading-[1.08] text-black/70" data-id="element-122" data-mp="3r61cfitmxbp0">
                {step}
              </p>
            </div>)}
        </div>

        <div className="mt-[2.2vh] grid min-h-0 grid-cols-[1fr_1fr] gap-[4vw]" data-id="element-123" data-mp="33evsargnvx8w">
          <section className="flex min-h-0 flex-col justify-center" data-id="element-124" data-mp="38dpagx6w8cfe">
            <p className="font-sans text-[clamp(10px,0.8vw,15px)] font-semibold tracking-[0.1em] text-[#D62B22]" data-id="element-125" data-mp="38cxdbhxne6n0">
              The message back
            </p>
            <p className="mt-[0.9vh] max-w-[22ch] font-display text-[clamp(23px,2.45vw,42px)] font-semibold leading-[1.08]" data-id="element-126" data-mp="196i94epmnszd">
              “You told us what matters. <span className="text-[#D62B22]" data-id="element-127" data-mp="1532cvjhgzun7">Here’s what the ECCO community said.</span>”
            </p>
          </section>

          <section className="min-h-0 border-l border-black/20 pl-[3vw]" data-id="element-128" data-mp="1ww2tn21fiyar">
            <p className="font-sans text-[clamp(10px,0.8vw,15px)] font-semibold tracking-[0.1em] text-[#D62B22]" data-id="element-129" data-mp="1wu07it3edpbb">
              What it enables
            </p>
            <div className="mt-[0.5vh] divide-y divide-black/15" data-id="element-130" data-mp="1nud3dzjaa5ek">
              {practicalValue.map((value, index) => <div key={value} className="flex items-center gap-[0.8vw] py-[0.58vh]" data-id="element-131" data-mp="1iwbo7pozaq8d" data-mpi={index}>
                  <span className="font-sans text-[clamp(9px,0.7vw,13px)] font-semibold text-black/30" data-id="element-132" data-mp="ci2jkimipjm9">
                    0{index + 1}
                  </span>
                  <p className="font-display text-[clamp(15px,1.35vw,24px)] font-medium leading-[1.08] text-black/70" data-id="element-133" data-mp="3tjdqqfriqz11">
                    {value}
                  </p>
                </div>)}
            </div>
          </section>
        </div>

        <div className="mt-[1.5vh] flex items-center justify-between gap-[3vw] border-t-[clamp(3px,0.3vw,5px)] border-[#D62B22] pt-[1.2vh]" data-id="element-134" data-mp="79kol2v5r2e4">
          <p className="font-display text-[clamp(23px,2.55vw,44px)] font-semibold leading-none" data-id="element-135" data-mp="g4h9gso8q3ht">
            The final act should open <span className="text-[#D62B22]" data-id="element-136" data-mp="l1r2eiau8xae">the next one.</span>
          </p>
          <span className="shrink-0 font-display text-[clamp(30px,3.2vw,56px)] font-light leading-none text-[#D62B22]" aria-hidden="true" data-id="element-137" data-mp="q1vl8ez7y43s">
            →
          </span>
        </div>
      </div>
    </SlideFrame>;
}